<template>
  <div>
    <v-card-text>
      <v-row>
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-skeleton-loader
                :loading="loading"
                height="94"
                type="list-item-two-line">
                <v-list-item-title
                  class="title"> {{last_name}} {{name}}
                </v-list-item-title>
                <v-list-item-subtitle>{{email}}</v-list-item-subtitle>

              </v-skeleton-loader>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <v-skeleton-loader
            :loading="loading"
            height="94"
            type="list-item-two-line">
          <v-text-field
          v-model="last_name"
          :label="surNameLabel"
          required></v-text-field>
          </v-skeleton-loader>
        </v-col>
        <v-col cols="12" md="4">
          <v-skeleton-loader
            :loading="loading"
            height="94"
            type="list-item-two-line">
            <v-text-field
              v-model="name"
              :label="nameLabel"
              required>
            </v-text-field>
          </v-skeleton-loader>
        </v-col>
        <v-col cols="12" md="4">
          <v-skeleton-loader
            :loading="loading"
            height="94"
            type="list-item-two-line">
          <v-text-field
              v-model="middle_name"
              :label="patronymicLabel" required>
            </v-text-field>
          </v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols='12'>
          <v-skeleton-loader
            :loading="loading"
            height="94"
            type="list-item-two-line">
          <v-autocomplete
            v-model="currentOrganization"
            :items="fullOrganizationArray"
            item-text="name"
            item-value="id"
            :label="scienceOrganizationLabel"
            prepend-icon="mdi-city"
          ></v-autocomplete>
          </v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row style="margin-top: -20px">
        <v-col class="pt-3" cols="12" lg="4">
          <v-checkbox
            class="mt-0"
            :color="$mainColor"
            v-model="checkbox_other_org"
            label="другая"
          ></v-checkbox>
        </v-col>
        <v-col class="pt-0" cols="12" lg="8">
          <v-text-field
            class="mt-0"
            v-if="checkbox_other_org"
            v-model="other_org_descr"
            placeholder="название организации"
            label="название организации"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols='12' lg="4">
          <v-skeleton-loader
            :loading="loading"
            height="94"
            type="list-item-two-line">
          <v-text-field
            v-model="phone"
            :label="phoneLabel"
            required
            prepend-icon="mdi-phone">
          </v-text-field>
        </v-skeleton-loader>
        </v-col>
          <v-col cols="12" lg="4">
            <v-skeleton-loader
            :loading="loading"
            height="94"
            type="list-item-two-line">
          <v-autocomplete
            v-model="currentDegree"
            :items="fullDegreeArray"
            item-text="title"
            item-value="id"
            :label='scienceDegreeLabel'
            prepend-icon="mdi-badge-account-outline">
          </v-autocomplete>
          </v-skeleton-loader>
        </v-col>
        <v-col cols="12" lg="4">
          <v-skeleton-loader
            :loading="loading"
            height="94"
            type="list-item-two-line">
            <v-autocomplete
              v-model="currentOrgPosition"
              :items="fullOrgPosinions"
              item-text="title"
              item-value="id"
              label='Должность'
              :error="!currentOrgPosition"
              prepend-icon="mdi-badge-account-outline">
            </v-autocomplete>
          </v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" lg="2" style="text-align: end;">
          <h1 class="switch__current-lang"  x-snall style=" padding-top: 19px;">Пол:</h1>
        </v-col>
        <v-col cols="12" lg="3" class="pt-0">
          <v-radio-group
            v-model="is_female"
            column
          >
            <v-radio
              label="Мужской"
              :value="false"
            ></v-radio>
            <v-radio
              label="Женский"
              :value="true"
            ></v-radio>
          </v-radio-group>
          <!-- <div class="d-flex " style="height:40px; margin-top:10px;">
            <h1 class="switch__current-lang"  x-snall style=" padding-top: 19px;">Пол: Мужской</h1>
            <v-switch  style="color:white;" v-model="is_female" label="Женский"></v-switch>
          </div> -->
        </v-col>
        <v-col cols="12" lg="3">
          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px">
            <template v-slot:activator="{ on }">
              <v-skeleton-loader

                :loading="loading"
                height="94"
                type="list-item-two-line">
                <v-text-field

                  v-model="computedDateFormatted"
                  :label="birthDayLabel"
                  :hint="hint"
                  persistent-hint
                  prepend-icon="mdi-calendar"
                  readonly
                  v-on="on"
                ></v-text-field>
              </v-skeleton-loader>
            </template>
            <v-date-picker 
              v-model="new_date" 
              no-title 
              @input="menu2 = false"
              locale='ru-RU'
              first-day-of-week=1
              scrollable
              min="1925-01-01"
              max="2015-12-31"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" lg="4">
          <v-skeleton-loader
            :loading="loading"
            height="94"
            type="list-item-two-line">
            <v-autocomplete
              v-model="currentNationality"
              :items="nationalities"
              item-text="name"
              item-value="name"
              label='Гражданство'
              prepend-icon="mdi-earth">
            </v-autocomplete>
          </v-skeleton-loader>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-btn
        color="#16336e"
        dark
        outlined
        label
        class="mr-4 ml-2"
        :loading="loaded"
        @click="save_btn"
      >сохранить личные данные</v-btn>
    </v-card-actions>

  </div>
</template>
<script>
import { validationMixin } from 'vuelidate';
import { required, maxLength, email } from 'vuelidate/lib/validators';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { parserDate, parserString } from '../../helpers/parserDate';

export default {
  mounted() {
    if(localStorage.isLoggedIn === undefined){
      this.$router.push('/login')
      return
    }

    this.uploadDataUser();
  },
  name: 'personalDataBase',
  mixins: [validationMixin],
  validations: {
    name: { required, maxLength: maxLength(10) },
    email: { required, email },
    select: { required },
    checkbox: {
      checked(val) {
        return val;
      },
    },
  },

  data: () => ({

    title: 'This will be the title',
    boilerplate: true,
    loading: false,
    name: '',
    middle_name: '',
    loginChecked: true,
    last_name: '',
    email: '',
    phone: '',
    model: null,
    academic_rank: null,
    currentDegree: null,
    currentOrganization: null,
    new_date: null,
    menu2: false,
    head_info: '',
    rules: {
      required: (value) => !!value || 'Required.',
      min: (v) => v.length >= 8 || 'Min 8 characters',
    },
    edit: false,
    organizations: null,
    fullDegreeArray: null,
    fullOrganizationArray: [],
    loaded: false,
    reg_count: 0,
    is_female: false,
    currentOrgPosition: null,
    fullOrgPosinions: null,
    currentNationality: null,
    checkbox_other_org: false,
    other_org_descr: '',
    nationalities: [
      {id: 1, name: 'РФ'},
      {id: 2, name: 'Беларусь'},
      {id: 3, name: 'Казахстан'},
      {id: 99, name: '...другое'},
      // {id: 1, name: ''},
    ],

  }),
  
  components: {
  },
  
  watch: {
    file(val) {
      if (val && typeof val === 'object') {
        this.validateFile(val) 
      }
    },
    checkbox_other_org(val){
      if(val){
        this.currentOrganization = 134
      }
      else
        if(this.currentOrganization == 134)
          this.currentOrganization = ''
    },
    currentOrganization(val){
      if(val == '134')
        this.checkbox_other_org = true
      else
        this.checkbox_other_org = false
    },
  },
  
  computed: {
    ...mapGetters([
      'GETTERS_LOGIN',
    ]),

    checkboxErrors() {
      const errors = [];
      if (!this.$v.checkbox.$dirty) return errors;
      return errors;
    },
    computedDateFormatted() {
      return this.formatDate(this.new_date);
    },
    surNameLabel() {
      return 'Фамилия';
    },
    scienceOrganizationLabel() {
      return 'Научная организация';
    },
    nameLabel() {
      return 'Имя';
    },
    patronymicLabel() {
      return 'Отчество';
    },
    hint() {
      return 'мм/дд/гггг формат';
    },
    birthDayLabel() {
      return 'Дата рождения'
    },
    phoneLabel() {
      return 'Телефон'
    },
    scienceRankLabel() {
      return 'Научное звание'
    },
    scienceDegreeLabel() {
      return 'Научная степень'
    },
    selectErrors() {
      const errors = [];
      if (!this.$v.select.$dirty) return errors;
      return errors;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.name.$dirty) return errors;
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      return errors;
    },

  },
  created() {
    this.loading = true;
  },

  methods: {
    ...mapActions([
      'UPDATE_INDIVIDUAL',
      'GET_ACADEMIC_DEGREE',
      'ORGANIZATION_HEADERS',
      'GET_PERSONAL_DATA',
      'logged',
      'GET_ORG_POSITION_LIST',
      'GET_SCHOOL_STATUS_LIST',
    ]),
    ...mapMutations([
      'UPDATE_OVERLAY',
    ]),


    async uploadDataUser() {
      try {
        this.loading =true;
        await this.logged({ token: localStorage.token });
        const degree = await this.GET_ACADEMIC_DEGREE();
        const organizations = await this.ORGANIZATION_HEADERS();
        const orgs_positions = await this.GET_ORG_POSITION_LIST();

        this.fullOrganizationArray = organizations.data;
        this.fullDegreeArray = degree.data;

        this.organizations = organizations.data.map((item) => item.name);
        this.fullOrgPosinions = orgs_positions.data;

        if (this.GETTERS_LOGIN) {
          this.edit = true;
          const data = await this.GET_PERSONAL_DATA();
          this.email = data.username;
          this.last_name = data.profiles[0].individual.last_name;
          this.phone = data.profiles[0].individual.phone_number;
          this.name = data.profiles[0].individual.first_name;
          this.middle_name = data.profiles[0].individual.middle_name || '';
          this.is_female = data.profiles[0].individual.is_female;
          this.currentOrgPosition = data.profiles[0].individual.org_position;
          this.currentNationality = data.profiles[0].individual.nationality;
          this.currentDegree = data.profiles[0].individual.academic_degree;
          this.currentOrganization = data.profiles[0].individual.organization;
          this.other_org_descr = data.profiles[0].individual.other_org_descr
          const currentDate = data.profiles[0].individual.birth_date
            && parserString(data.profiles[0].individual.birth_date);
          this.new_date = currentDate || '';
        }
        this.loading = false;
      } catch (ex) {
        this.loginChecked = false;
        console.log('ex ---> ', ex);
      }
    },

    get_params() {
      return {
        id: this.GETTERS_LOGIN,
        first_name: this.name,
        last_name: this.last_name,
        middle_name: this.middle_name,
        birth_date: parserDate(this.new_date),
        phone_number: this.phone,
        academic_degree: this.currentDegree,
        organization: this.currentOrganization,
        org_position: this.currentOrgPosition,
        is_female: this.is_female,
        nationality: this.currentNationality,
      };
    },

    async save_btn() {
      this.boilerplate = true;
      this.loaded = true;

      var args = this.get_params()
      if(this.checkbox_other_org)
        args['other_org_descr'] = this.other_org_descr

      await this.UPDATE_INDIVIDUAL(args)
        .then((res) => {
          if (res.status === 200) this.$messageHelper('Данные сохранены', 'success', 3000);
          this.loaded = false;
        })
        .catch((e) => {
          this.dialog = true;
          this.loaded = false;
          this.head_info = 'ошибка';
          this.info = `${e}`;
          this.$messageHelper(`${e}`, 'error', 3000);
        });
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${day}.${month}.${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
  }
};
</script>
<style lang="scss" scoped>
  .description-upload-photo{
    display: none;
    position: absolute;
    background: black;
    color: white;
    opacity: 0.65;
    top:45px;
  }
  .avatar:hover .description-upload-photo{
    display: block;
  }
  .upload{
    opacity: 0;
  }
  .description-photo{
    top:-20px;
  }
  input[type=file] {
    opacity: 0;
    cursor: pointer;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
  .content-personal{
    -webkit-box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
    box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
    border-width: 0;
    -webkit-transition: all .2s;
    transition: all .2s;
    background-color: #fff;
    border-radius: 13px!important;
}
.theme--light.v-application {
    background: rgb(248, 248, 248) !important;
    color: rgba(0, 0, 0, 0.87);
}

@media screen and (max-width:767px) {
  .content-personal {
    max-width: 90% !important;
  }
  .content-personal__header {
    flex-direction: column;
  }
}
</style>
